<div class="wrapper">
    <app-drawing-canvas
        [clearCanvasAfterDrawing]="false"
        (drawn)="handleDrawn($event)"
    ></app-drawing-canvas>

    <app-button
        (click)="save()"
        class="outset-with-icon outset-with-icon--big button-save"
    >
        <i class="fas fa-save"></i>
        <span i18n>Opslaan</span>
    </app-button>

    <app-button
        (click)="print()"
        class="outset-with-icon outset-with-icon--big button-print"
    >
        <i class="fas fa-print"></i>
        <span i18n>Print</span>
    </app-button>
</div>

@if (preview) {
<img [src]="preview" class="image-tool-preview" />
}
